module.exports = __webpack_public_path__ + "616af5d4cb157f50e268cc5c9a0aecde.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/camp8.jpeg
// module id = 1142
// module chunks = 0